/* eslint-disable arrow-body-style */
import React from 'react';
import { Col, Layout, Row } from 'tea-component';
import MetricsCard from '../../components/MetricsCard';
import MetricsCardWithRank from '../../components/MetricsCardWithRank';
import dateTimeFormat from '@home/utils/dbDataFormat/dateTimeFormat';
import MetricsCardMulti from '../../components/MetricsCardMulti';
import MetricsTrendChart from '../../components/MetricsTrendChart';
import { MetricsTrendChartData } from './test';
import MetricsCardTrendChart from '../../components/MetricsCardTrendChart';

const { Content } = Layout;
const Card = () => {

  // const { metricsCardWrap, metricsCardValue, metricsCardDod } = props;

  const contentHeader = (
    <div className={"cart-margin-text"}>{dateTimeFormat('12.50', 'HH:mm')}</div>
  );

  return <Content className="dbd-scroll-body">
    <Content.Header
      className="dbd-scroll-body dbd-custom-page-box"
      title='经分卡片自测'
    >
    </Content.Header>
    <Content.Body full>
      <Row>
        <Col span={12}>
          <MetricsTrendChart
            metricData={MetricsTrendChartData}
            loading={false}
            error={false}
            filterVal={{ timeType: 'Day' }}
            // labelFormatRule={'thousandsInit'}
            // yAxisFormatRule={'bmk'}
            titleEn='Profit'
            titleCn='利润'
            componentMetrics={[{
              metricKey: "active_users",
              reqMetricKey: "active_users",
              formatRule: "thousandsInit",
              nameEn: 'This Month',
              nameCn: '本月',
              isCompare: true,
              compareNameEn: 'Same Month Last Year',
              compareNameCn: '去年同期',
              compareTableNameEn: 'SMLY',
              compareTableNameCn: '去年同期',
              compareToolTipNameEn: 'SMLY',
              compareToolTipNameCn: '去年同期',
            }]}
            showConfig={{
              showLineChart: true,
              showTable: true,
              showDownloadTable: true,
              showBubbleTitle: true,
            }}
            setOtherConfigFunc={(opt: any) => {
              opt.series[0].markLine = {
                silent: true,
                symbol: ['none', 'none'],
                label: {
                  formatter: (params: any) => {
                    const name = params.name;
                    const value = params.value;
                    return `${name} ${value}`;
                  },
                  position: 'insideEndTop',
                  color: 'red',
                },
                lineStyle: { color: 'red' },
                data: [{ yAxis: 3500, name: 'KPI' }]
              };
              return opt;
            }}
          />
        </Col>
        <Col span={12}>
          <MetricsCardWithRank
            titleCn='日平均活量'
            titleEn='Avg. DAU'
            rankClassName='dbd-metrics-card-with-rank__flex'
            link='/engagement/active'
            tipsEn='Daily Active Users.Number of users who have logged in to the game during the statistical period (vopenid deduplicated).Date more than 1 day shows averageDAU.'
            tipsCn='统计周期内登录过游戏的用户数(vopenid数去重)，超过一天展示平均日活。'
            icon='user-u'
            subtitleCn='Estimated'
            subtitleEn='Estimated'
            value={3894}
            dodData={[
              {
                titleEn: 'DOD',
                titleCn: '日环比',
                subTitleEn: '(Day on Day)',
                subTitleCn: '',
                formatRule: 'percent1Decimal',
                extendFormatRule: 'thousandsInit',
                thisTime: '2024-06-27',
                lastTime: '2024-06-26',
                value: '-0.022',
                thisValue: '3894',
                lastValue: '3936'
              },
              {
                titleEn: 'SDLW',
                titleCn: '上周同期',
                subTitleEn: '(Same Day Last Week)',
                subTitleCn: '',
                formatRule: 'percent1Decimal',
                extendFormatRule: 'thousandsInit',
                thisTime: '2024-06-27',
                lastTime: '2024-06-20',
                value: -0.041,
                thisValue: 3849,
                lastValue: 4014
              }
            ]}
            rankData={[{
              icon: "data:image/svg+xml;base64,CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTUuOTkgMTUuOTkiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojMTYxNjE2O308L3N0eWxlPjwvZGVmcz48ZyBpZD0i5Zu+5bGCXzIiIGRhdGEtbmFtZT0i5Zu+5bGCIDIiPjxnIGlkPSLlm77lsYJfMS0yIiBkYXRhLW5hbWU9IuWbvuWxgiAxIj48cGF0aCBkPSJNMTMuMTcsNC4yNGE2LjQxLDYuNDEsMCwwLDEsMCw3LjUxbDEuMTQsMS4xNGE4LDgsMCwwLDAsMC05LjhaIi8+PHBhdGggZD0iTTQuMjQsMi44MmE2LjQxLDYuNDEsMCwwLDEsNy41MSwwbDEuMTQtMS4xNGE4LDgsMCwwLDAtOS44LDBaIi8+PHBhdGggZD0iTTIuODIsMTEuNzVhNi40MSw2LjQxLDAsMCwxLDAtNy41MUwxLjY4LDMuMDlhOCw4LDAsMCwwLDAsOS44WiIvPjxwYXRoIGQ9Ik0xMS43NSwxMy4xN2E2LjQxLDYuNDEsMCwwLDEtNy41MSwwTDMuMDksMTQuMzFhOCw4LDAsMCwwLDkuOCwwWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTkuNzYsNi41MWExLDEsMCwwLDAsLjQxLjA5LDEsMSwwLDEsMC0xLTFzMCwuMDYsMCwuMDlMNyw3LjIxYTEuMjIsMS4yMiwwLDAsMC0uOTItLjQzLDEuMjUsMS4yNSwwLDEsMCwwLDIuNUExLjI0LDEuMjQsMCwwLDAsNi45LDlMOC44NSwxMC4zYS4yNC4yNCwwLDAsMCwwLC4wOCwxLDEsMCwxLDAsMS0xLC45Mi45MiwwLDAsMC0uNDEuMWwtMi0xLjM3WiIvPjwvZz48L2c+PC9zdmc+",
              disableIcon: "data:image/svg+xml;base64,CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTUuOTkgMTUuOTkiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojMTYxNjE2O308L3N0eWxlPjwvZGVmcz48ZyBpZD0i5Zu+5bGCXzIiIGRhdGEtbmFtZT0i5Zu+5bGCIDIiPjxnIGlkPSLlm77lsYJfMS0yIiBkYXRhLW5hbWU9IuWbvuWxgiAxIj48cGF0aCBkPSJNMTMuMTcsNC4yNGE2LjQxLDYuNDEsMCwwLDEsMCw3LjUxbDEuMTQsMS4xNGE4LDgsMCwwLDAsMC05LjhaIi8+PHBhdGggZD0iTTQuMjQsMi44MmE2LjQxLDYuNDEsMCwwLDEsNy41MSwwbDEuMTQtMS4xNGE4LDgsMCwwLDAtOS44LDBaIi8+PHBhdGggZD0iTTIuODIsMTEuNzVhNi40MSw2LjQxLDAsMCwxLDAtNy41MUwxLjY4LDMuMDlhOCw4LDAsMCwwLDAsOS44WiIvPjxwYXRoIGQ9Ik0xMS43NSwxMy4xN2E2LjQxLDYuNDEsMCwwLDEtNy41MSwwTDMuMDksMTQuMzFhOCw4LDAsMCwwLDkuOCwwWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTkuNzYsNi41MWExLDEsMCwwLDAsLjQxLjA5LDEsMSwwLDEsMC0xLTFzMCwuMDYsMCwuMDlMNyw3LjIxYTEuMjIsMS4yMiwwLDAsMC0uOTItLjQzLDEuMjUsMS4yNSwwLDEsMCwwLDIuNUExLjI0LDEuMjQsMCwwLDAsNi45LDlMOC44NSwxMC4zYS4yNC4yNCwwLDAsMCwwLC4wOCwxLDEsMCwxLDAsMS0xLC45Mi45MiwwLDAsMC0uNDEuMWwtMi0xLjM3WiIvPjwvZz48L2c+PC9zdmc+",
              nameEn: "PC Launcher",
              color: "#5EC8F1",
              value: "2291.14",
              subValue: 0.5681
            },
            {
              icon: "data:image/svg+xml;base64,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",
              disableIcon: "data:image/svg+xml;base64,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",
              nameEn: "Playstation",
              color: "#587EDB",
              value: "1083.49",
              subValue: 0.26523
            },
            {
              icon: "data:image/svg+xml;base64,PHN2ZyBpZD0iU3RlYW1fMV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+DQogIDxkZWZzPg0KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB4MT0iMC41IiB4Mj0iMC41IiB5Mj0iMSIgZ3JhZGllbnRVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giPg0KICAgICAgPHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjMGYxYzMwIi8+DQogICAgICA8c3RvcCBvZmZzZXQ9IjAuNCIgc3RvcC1jb2xvcj0iIzBlMjQ1NCIvPg0KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMTM4MmIzIi8+DQogICAgPC9saW5lYXJHcmFkaWVudD4NCiAgPC9kZWZzPg0KICA8ZyBpZD0iU3RlYW1fMV8iPg0KICAgIDxwYXRoIGlkPSLnn6nlvaJfMjI0OV8xXyIgZD0iTTM4Ni45LDQyNC43aDEyYTIuMDA2LDIuMDA2LDAsMCwxLDIsMnYxMmEyLjAwNiwyLjAwNiwwLDAsMS0yLDJoLTEyYTIuMDA2LDIuMDA2LDAsMCwxLTItMnYtMTJBMi4wMDYsMi4wMDYsMCwwLDEsMzg2LjksNDI0LjdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzg0LjkgLTQyNC43KSIgZmlsbD0icmdiYSgyNTUsMjU1LDI1NSwwKSIvPg0KICAgIDxwYXRoIGlkPSLot6/lvoRfNjQ4OF8xXyIgZD0iTTQwMC42LDQzMy4xYTYuOTg3LDYuOTg3LDAsMCwxLTcuMTA5LDYuODg4LDYuOSw2LjksMCwwLDEtNi43ODEtNC45ODFsMi43MzQsMS4wNmEyLjAxNiwyLjAxNiwwLDAsMCwyLjQwNiwxLjQ4NCwyLjA1NiwyLjA1NiwwLDAsMCwxLjY0MS0yLjAxNGwyLjQwNi0xLjdhMi42LDIuNiwwLDEsMC0yLjYyNS0yLjY0OWgwbC0xLjY0MSwyLjMzMWEyLjI1OSwyLjI1OSwwLDAsMC0xLjIuMzE4bC0zLjgyOC0xLjQ4NEE3LjEyMiw3LjEyMiwwLDAsMSwzOTQuMjU2LDQyNiw3LjM2MSw3LjM2MSwwLDAsMSw0MDAuNiw0MzMuMVptLTkuNzM0LDMuNi0uODc1LS4zMThhMS40MDYsMS40MDYsMCwwLDAsMS45NjkuNjM2LDEuNywxLjcsMCwwLDAsLjc2Ni0uNzQyLDEuNDIxLDEuNDIxLDAsMCwwLS43NjYtMS45MDgsMS45MjEsMS45MjEsMCwwLDAtMS4wOTQsMGwuODc1LjMxOGEuOTYxLjk2MSwwLDAsMSwuNTQ3LDEuMzc4LDEuMiwxLjIsMCwwLDEtMS40MjIuNjM2Wm00LjkyMi0zLjZhMS43LDEuNywwLDEsMSwxLjc1LTEuN0ExLjc3MSwxLjc3MSwwLDAsMSwzOTUuNzg4LDQzMy4xWm0wLS41M2ExLjI3MiwxLjI3MiwwLDEsMC0xLjMxMi0xLjI3MiwxLjI0NCwxLjI0NCwwLDAsMCwxLjMxMywxLjI3MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zODUuNiAtNDI0Ljk4OSkiIGZpbGw9InVybCgjbGluZWFyLWdyYWRpZW50KSIvPg0KICA8L2c+DQo8L3N2Zz4NCg==",
              disableIcon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgPGcgaWQ9Iue7hF8yNDkzMyIgZGF0YS1uYW1lPSLnu4QgMjQ5MzMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNTA1IC0xMTExKSI+DQogICAgPHJlY3QgaWQ9IuefqeW9ol8xODEzNyIgZGF0YS1uYW1lPSLnn6nlvaIgMTgxMzciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjUwNSAxMTExKSIgZmlsbD0ibm9uZSIgb3BhY2l0eT0iMCIvPg0KICAgIDxwYXRoIGlkPSLot6/lvoRfNjQ4OF8xXyIgZD0iTTQwMy44Miw0MzQuNzM3YTguNiw4LjYsMCwwLDEtOC43NDUsOC40NzMsOC40ODUsOC40ODUsMCwwLDEtOC4zNDEtNi4xMjZsMy4zNjMsMS4zYTIuNDgsMi40OCwwLDAsMCwyLjk2LDEuODI1LDIuNTI5LDIuNTI5LDAsMCwwLDIuMDE4LTIuNDc3bDIuOTYtMi4wODZhMy4yLDMuMiwwLDEsMC0zLjIyOS0zLjI1OWgwbC0yLjAxOCwyLjg2OGEyLjc3OSwyLjc3OSwwLDAsMC0xLjQ4LjM5MWwtNC43MDktMS44MjVBOC43Niw4Ljc2LDAsMCwxLDM5Ni4wMTcsNDI2LDkuMDU1LDkuMDU1LDAsMCwxLDQwMy44Miw0MzQuNzM3Wm0tMTEuOTczLDQuNDMyLTEuMDc2LS4zOTFhMS43MjksMS43MjksMCwwLDAsMi40MjIuNzgyLDIuMDg5LDIuMDg5LDAsMCwwLC45NDItLjkxMiwxLjc0NywxLjc0NywwLDAsMC0uOTQyLTIuMzQ2LDIuMzYzLDIuMzYzLDAsMCwwLTEuMzQ1LDBsMS4wNzYuMzkxYTEuMTgzLDEuMTgzLDAsMCwxLC42NzMsMS42OTUsMS40NzIsMS40NzIsMCwwLDEtMS43NDkuNzgyWm02LjA1NC00LjQzMmEyLjA4NywyLjA4NywwLDEsMSwyLjE1Mi0yLjA4NkEyLjE3OCwyLjE3OCwwLDAsMSwzOTcuOSw0MzQuNzM3Wm0wLS42NTJhMS41NjUsMS41NjUsMCwxLDAtMS42MTQtMS41NjQsMS41MzEsMS41MzEsMCwwLDAsMS42MTQsMS41NjRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTE5Ljc5IDY4Ni40MDEpIiBmaWxsPSIjZDhkYWU0Ii8+DQogIDwvZz4NCjwvc3ZnPg0K",
              nameEn: "Steam",
              color: "#326282",
              value: "604.27",
              subValue: 0.15
            },
            {
              icon: "data:image/svg+xml;base64,PHN2ZyBpZD0iWEJPWCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+DQogIDxnIGlkPSJYYm94XzFfIj4NCiAgICA8cGF0aCBpZD0i55+p5b2iXzIyNTFfMV8iIGQ9Ik03MC4yLDQ1OS4xaDEyYTIuMDA2LDIuMDA2LDAsMCwxLDIsMnYxMmEyLjAwNiwyLjAwNiwwLDAsMS0yLDJoLTEyYTIuMDA2LDIuMDA2LDAsMCwxLTItMnYtMTJBMi4wMDYsMi4wMDYsMCwwLDEsNzAuMiw0NTkuMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02OC4yIC00NTkuMSkiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMCkiLz4NCiAgICA8cGF0aCBpZD0i6IGU5ZCIXzY3Ml8xXyIgZD0iTTcxLjc2Nyw0NzIuMzl2LS4xMWExMi4yNSwxMi4yNSwwLDAsMSwxLjg3OC0zLjMxNCwxMy4yNzMsMTMuMjczLDAsMCwxLDMuMi0yLjg3MiwxNS43MjQsMTUuNzI0LDAsMCwxLDMuMiwyLjg3Miw4LjMxMyw4LjMxMywwLDAsMSwxLjg3OCwzLjMxNHYuMTFhNi43MTcsNi43MTcsMCwwLDEtOS42MS41NTIsMS4zMzEsMS4zMzEsMCwwLDEtLjU1Mi0uNTUyWm05LjA1Ny00Ljc1YTE5LjcwOSwxOS43MDksMCwwLDAtMi40My0yLjg3Miw3Ljc0Miw3Ljc0MiwwLDAsMSwyLjg3Mi0yLjFoLjExYTYuODksNi44OSwwLDAsMSwuOTk0LDkuMzg5QTguNSw4LjUsMCwwLDAsODAuODI1LDQ2Ny42NFpNNzAsNDY3Ljg2MWE2LjgyOCw2LjgyOCwwLDAsMSwyLjQzLTUuMTkxaC4xMWE3Ljc0Miw3Ljc0MiwwLDAsMSwyLjg3MiwyLjEsMTkuNywxOS43LDAsMCwwLTIuNDMsMi44NzIsOS4yNDksOS4yNDksMCwwLDAtMS41NDYsNC40MThBNi42NjgsNi42NjgsMCwwLDEsNzAsNDY3Ljg2MVptNS4xOTEtNS40MTJhMy43NTMsMy43NTMsMCwwLDAtMi4yMDktLjMzMSw2LjYzNSw2LjYzNSwwLDAsMSw3LjczMiwwLDMuNzUzLDMuNzUzLDAsMCwwLTIuMjA5LjMzMSw4LjY2MSw4LjY2MSwwLDAsMC0xLjY1NywxLjFBNC44MjMsNC44MjMsMCwwLDAsNzUuMTkxLDQ2Mi40NDlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjguODUyIC00NTkuNzU1KSIgZmlsbD0iIzEwN2MxMCIvPg0KICA8L2c+DQo8L3N2Zz4NCg==",
              disableIcon: "data:image/svg+xml;base64,PHN2ZyBpZD0iWGJveF8xXyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCI+DQogIDxwYXRoIGlkPSLnn6nlvaJfMjI1MV8xXyIgZD0iTTcwLjcsNDU5LjFoMTVhMi41MDcsMi41MDcsMCwwLDEsMi41LDIuNXYxNWEyLjUwNywyLjUwNywwLDAsMS0yLjUsMi41aC0xNWEyLjUwNywyLjUwNywwLDAsMS0yLjUtMi41di0xNUEyLjUwNywyLjUwNywwLDAsMSw3MC43LDQ1OS4xWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTY4LjIgLTQ1OS4xKSIgZmlsbD0ibm9uZSIgb3BhY2l0eT0iMCIvPg0KICA8cGF0aCBpZD0i6IGU5ZCIXzY3Ml8xXyIgZD0iTTcyLjE4MSw0NzUuMDI4di0uMTM2YTE1LjA0LDE1LjA0LDAsMCwxLDIuMzE3LTQuMDczLDE2LjM1NSwxNi4zNTUsMCwwLDEsMy45NTMtMy41MywxOS4zNzYsMTkuMzc2LDAsMCwxLDMuOTUzLDMuNTMsMTAuMjA3LDEwLjIwNywwLDAsMSwyLjMxNyw0LjA3M3YuMTM2YTguMzEyLDguMzEyLDAsMCwxLTExLjg1OC42NzksMS42MzksMS42MzksMCwwLDEtLjY4MS0uNjc5Wm0xMS4xNzctNS44MzhhMjQuMjUsMjQuMjUsMCwwLDAtMy0zLjUzLDkuNTUxLDkuNTUxLDAsMCwxLDMuNTQ0LTIuNTc5aC4xMzZhOC40NDYsOC40NDYsMCwwLDEsMS4yMjcsMTEuNTRBMTAuNDIxLDEwLjQyMSwwLDAsMCw4My4zNTcsNDY5LjE5Wk03MCw0NjkuNDYyYTguMzgsOC4zOCwwLDAsMSwzLTYuMzgxaC4xMzZhOS41NTEsOS41NTEsMCwwLDEsMy41NDQsMi41NzksMjQuMjQyLDI0LjI0MiwwLDAsMC0zLDMuNTMsMTEuMzM5LDExLjMzOSwwLDAsMC0xLjkwOCw1LjQzQTguMTc2LDguMTc2LDAsMCwxLDcwLDQ2OS40NjJabTYuNDA2LTYuNjUyYTQuNjQ4LDQuNjQ4LDAsMCwwLTIuNzI2LS40MDcsOC4yMTQsOC4yMTQsMCwwLDEsOS41NDEsMCw0LjY0OCw0LjY0OCwwLDAsMC0yLjcyNi40MDcsMTAuNjksMTAuNjksMCwwLDAtMi4wNDQsMS4zNThBNS45NTMsNS45NTMsMCwwLDAsNzYuNDA2LDQ2Mi44MVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02OC41IC00NTkuMzc1KSIgZmlsbD0iI2Q4ZGFlNCIvPg0KPC9zdmc+DQo=",
              nameEn: "XBox",
              color: "#4DAB7D",
              value: "-",
              subValue: 0
            }]}
          />
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <MetricsCard
            titleCn={'日平均活量'}
            titleEn={'Avg. DAU'}
            // link={'/engagement/active'}
            tipsEn={'Daily Active Users.Number of users who have logged in to the game during the statistical period (vopenid deduplicated).Date more than 1 day shows averageDAU.'}
            tipsCn='统计周期内登录过游戏的用户数(vopenid数去重)，超过一天展示平均日活。'
            isIconTips={true}
            // icon='user-u'
            imgUrl='https://ogdb-cdn.intlgame.cn/image/d5c8efae20e94f8da3409f8ad378e455.jpg'
            subtitleCn='Estimated'
            subtitleEn='Estimated'
            contentHeader={contentHeader}
            value={3894}
            dodData={[
              {
                titleEn: 'DOD',
                titleCn: '日环比',
                subTitleEn: '(Day on Day)',
                subTitleCn: '',
                formatRule: 'percent1Decimal',
                extendFormatRule: 'thousandsInit',
                thisTime: '2024-06-27',
                lastTime: '2024-06-26',
                value: '-0.022',
                thisValue: '3894',
                lastValue: '3936'
              },
              {
                titleEn: 'SDLW',
                titleCn: '上周同期',
                subTitleEn: '(Same Day Last Week)',
                subTitleCn: '',
                formatRule: 'percent1Decimal',
                extendFormatRule: 'thousandsInit',
                thisTime: '2024-06-27',
                lastTime: '2024-06-20',
                value: -0.041,
                thisValue: 3849,
                lastValue: 4014
              }
            ]}
            metricsChart={<MetricsCardTrendChart
              titleEn={'Avg. DAU'}
              titleCn={'日平均活量'}
              metricData={MetricsTrendChartData}
              isLeftCard={true}
              loading={false}
              error={false}
              filterVal={{ timeType: 'Day' }}
              componentMetrics={[{
                metricKey: "active_users",
                reqMetricKey: "active_users",
                formatRule: "thousandsInit",
                nameEn: 'This Month',
                nameCn: '本月',
                isCompare: true,
                compareNameEn: 'Same Month Last Year',
                compareNameCn: '去年同期',
                compareTableNameEn: 'SMLY',
                compareTableNameCn: '去年同期',
                compareToolTipNameEn: 'SMLY',
                compareToolTipNameCn: '去年同期',
              }]}
            />}
          >
          </MetricsCard>
        </Col>
        <Col span={8}>
          <MetricsCard
            titleCn='日平均活量'
            titleEn='Avg. DAU'
            link='/engagement/active'
            tipsEn='Daily Active Users.Number of users who have logged in to the game during the statistical period (vopenid deduplicated).Date more than 1 day shows averageDAU.'
            tipsCn='统计周期内登录过游戏的用户数(vopenid数去重)，超过一天展示平均日活。'
            // icon='user-u'
            imgUrl='https://ogdb-cdn.intlgame.cn/image/0c229eb16a0e02eb378f6ec1e85d6a4d.jpg'
            subtitleCn='Estimated'
            subtitleEn='Estimated'
            value={4994}
            dodData={[
              {
                titleEn: 'DOD',
                titleCn: '日环比',
                subTitleEn: '(Day on Day)',
                subTitleCn: '',
                formatRule: 'percent1Decimal',
                extendFormatRule: 'thousandsInit',
                thisTime: '2024-06-27',
                lastTime: '2024-06-26',
                value: '-0.022',
                thisValue: '3894',
                lastValue: '3936'
              },
              {
                titleEn: 'SDLW',
                titleCn: '上周同期',
                subTitleEn: '(Same Day Last Week)',
                subTitleCn: '',
                formatRule: 'percent1Decimal',
                extendFormatRule: 'thousandsInit',
                thisTime: '2024-06-27',
                lastTime: '2024-06-20',
                value: -0.041,
                thisValue: 3849,
                lastValue: 4014
              }
            ]}
          >
          </MetricsCard>
        </Col>
        <Col span={8}>
          <MetricsCardMulti
            titleCn='日平均活量'
            titleEn='Avg. DAU'
            link='/engagement/active'
            tipsEn='Daily Active Users.Number of users who have logged in to the game during the statistical period (vopenid deduplicated).Date more than 1 day shows averageDAU.'
            tipsCn='统计周期内登录过游戏的用户数(vopenid数去重)，超过一天展示平均日活。'
            icon='user-u'
            subtitleCn='Estimated'
            subtitleEn='Estimated'
            contentHeader={contentHeader}
            value={3894}
            dodData={[
              {
                titleEn: 'DOD',
                titleCn: '日环比',
                subTitleEn: '(Day on Day)',
                subTitleCn: '',
                formatRule: 'percent1Decimal',
                extendFormatRule: 'thousandsInit',
                thisTime: '2024-06-27',
                lastTime: '2024-06-26',
                value: '-0.022',
                thisValue: '3894',
                lastValue: '3936'
              },
              {
                titleEn: 'SDLW',
                titleCn: '上周同期',
                subTitleEn: '(Same Day Last Week)',
                subTitleCn: '',
                formatRule: 'percent1Decimal',
                extendFormatRule: 'thousandsInit',
                thisTime: '2024-06-27',
                lastTime: '2024-06-20',
                value: -0.041,
                thisValue: 3849,
                lastValue: 4014
              }
            ]}
            metricsCardItem={[
              {
                titleEn: 'D2(T-2)',
                titleCn: '',
                value: '0.1544',
                formatRule: 'percent2Decimal',
                valueStyle: {
                  fontWeight: 700,
                  fontSize: '16px',
                  color: 'var(--color-neutral-8)',
                  fontFamily: 'num-m',
                  marginBottom: '6px'
                },
                dodData: [{
                  titleEn: 'DOD',
                  titleCn: '日环比',
                  subTitleEn: '(Day on Day)',
                  subTitleCn: '',
                  formatRule: 'percent1Decimal',
                  extendFormatRule: 'percent2Decimal',
                  thisTime: '2024-06-27',
                  lastTime: '2024-06-26',
                  value: '0.435',
                  thisValue: '0.1544',
                  lastValue: '0.1076'
                },
                {
                  titleEn: 'SDLW',
                  titleCn: '上周同期',
                  subTitleEn: '(Same Day Last Week)',
                  subTitleCn: '',
                  formatRule: 'percent1Decimal',
                  extendFormatRule: 'percent2Decimal',
                  thisTime: '2024-06-27',
                  lastTime: '2024-06-20',
                  value: 0.102,
                  thisValue: 0.1544,
                  lastValue: 0.1401
                }]
              },
              {
                titleEn: 'D7(T-2)',
                titleCn: '',
                value: '0.1744',
                formatRule: 'percent2Decimal',
                valueStyle: {
                  fontWeight: 700,
                  fontSize: '16px',
                  color: 'var(--color-neutral-8)',
                  fontFamily: 'num-m',
                  marginBottom: '6px'
                },
                dodData: [{
                  titleEn: 'DOD',
                  titleCn: '日环比',
                  subTitleEn: '(Day on Day)',
                  subTitleCn: '',
                  formatRule: 'percent1Decimal',
                  extendFormatRule: 'percent2Decimal',
                  thisTime: '2024-06-27',
                  lastTime: '2024-06-26',
                  value: 0.035,
                  thisValue: '0.1744',
                  lastValue: '0.1776'
                },
                {
                  titleEn: 'SDLW',
                  titleCn: '上周同期',
                  subTitleEn: '(Same Day Last Week)',
                  subTitleCn: '',
                  formatRule: 'percent1Decimal',
                  extendFormatRule: 'percent2Decimal',
                  thisTime: '2024-06-27',
                  lastTime: '2024-06-20',
                  value: 0.012,
                  thisValue: 0.1844,
                  lastValue: 0.1801
                }]
              },
            ]}
            metricsChart={
              <MetricsCardTrendChart
                titleEn={'Avg. DAU Avg. DAU Avg. DAU'}
                titleCn={'日平均活量 日平均活量 日平均活量'}
                metricData={MetricsTrendChartData}
                loading={false}
                error={false}
                isRightCard={true}
                filterVal={{ timeType: 'Day' }}
                componentMetrics={[{
                  metricKey: "active_users",
                  reqMetricKey: "active_users",
                  formatRule: "thousandsInit",
                  nameEn: 'This Month',
                  nameCn: '本月',
                  isCompare: true,
                  compareNameEn: 'Same Month Last Year',
                  compareNameCn: '去年同期',
                  compareTableNameEn: 'SMLY',
                  compareTableNameCn: '去年同期',
                  compareToolTipNameEn: 'SMLY',
                  compareToolTipNameCn: '去年同期',
                }]}
              />
            }
          />
        </Col>
      </Row>
    </Content.Body>

  </Content>;
};

export default Card;
